<script setup>
import { computed } from "vue";

const props = defineProps({
  min: { type: Number, required: true },
  median: { type: Number, required: true },
  avg: { type: Number, required: true },
  max: { type: Number, required: true },
  scaleMax: { type: Number, default: 20 },
});

const W = 600;
const H = 60;
const pad = { l: 10, r: 10 };
const y = 30;

const X = (v) => pad.l + (v / props.scaleMax) * (W - pad.l - pad.r);

const markers = computed(() => [
  { x: X(props.min), color: "#5c6e8c", label: props.min.toFixed(1) },
  { x: X(props.median), color: "#34d399", label: props.median.toFixed(1) },
  { x: X(props.avg), color: "#38bdf8", label: props.avg.toFixed(1) },
  { x: X(props.max), color: "#fb7185", label: props.max.toFixed(1) },
]);
</script>

<template>
  <svg class="an-chart" style="height: 60px" :viewBox="`0 0 ${W} ${H}`" preserveAspectRatio="none">
    <line :x1="X(min)" :x2="X(max)" :y1="y" :y2="y" stroke="var(--an-line)" stroke-width="6" stroke-linecap="round" vector-effect="non-scaling-stroke" />
    <line :x1="X(min)" :x2="X(avg)" :y1="y" :y2="y" stroke="#38bdf8" stroke-width="6" stroke-linecap="round" vector-effect="non-scaling-stroke" />
    <template v-for="(m, i) in markers" :key="i">
      <line :x1="m.x" :x2="m.x" :y1="y - 11" :y2="y + 11" :stroke="m.color" stroke-width="2.5" vector-effect="non-scaling-stroke" />
      <text :x="m.x" :y="y + 24" text-anchor="middle" class="an-axis">{{ m.label }}</text>
    </template>
  </svg>
</template>
